import { defineLocaleTargets } from './utilities';

export const AccessibilityLocales = defineLocaleTargets('accessibility', <const>{
	closeMenu: '',
	openMenu: '',
});
